class StickyHeader extends HTMLElement {
  connectedCallback() {
    this.lastScrollY = window.scrollY;
    this.isHidden = false;

    this.menuToggle = this.querySelector('.header__menu-toggle');
    this.mobileMenu = this.querySelector('.header__mobile-menu');
    this.mobileClose = this.querySelector('.header__mobile-close');
    this.cartBtn = this.querySelector('.header__cart-btn');
    this.cartCount = this.querySelector('.header__cart-count');

    this._onScroll = this._onScroll.bind(this);
    window.addEventListener('scroll', this._onScroll, { passive: true });

    if (this.menuToggle && this.mobileMenu) {
      this.menuToggle.addEventListener('click', () => this._openMenu());
    }
    if (this.mobileClose) {
      this.mobileClose.addEventListener('click', () => this._closeMenu());
    }
    if (this.cartBtn) {
      this.cartBtn.addEventListener('click', (e) => {
        if (this.cartBtn.dataset.cartType === 'drawer') {
          e.preventDefault();
          document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
        }
      });
    }

    /* Language switcher dropdowns (document-wide to include footer) */
    document.querySelectorAll('[data-lang-switcher]').forEach((switcher) => {
      var trigger = switcher.querySelector('[data-lang-trigger]');
      var dropdown = switcher.querySelector('[data-lang-dropdown]');
      if (!trigger || !dropdown) return;

      trigger.addEventListener('click', function () {
        var isOpen = dropdown.classList.contains('is-open');
        /* Close all other dropdowns first */
        document.querySelectorAll('[data-lang-dropdown].is-open').forEach(function (d) {
          d.classList.remove('is-open');
          d.closest('[data-lang-switcher]').querySelector('[data-lang-trigger]').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          dropdown.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });

    /* Close language dropdown on outside click */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-lang-switcher]')) {
        document.querySelectorAll('[data-lang-dropdown].is-open').forEach(function (d) {
          d.classList.remove('is-open');
          d.closest('[data-lang-switcher]').querySelector('[data-lang-trigger]').setAttribute('aria-expanded', 'false');
        });
      }
    });

    /* Close language dropdown on Escape */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('[data-lang-dropdown].is-open').forEach(function (d) {
          d.classList.remove('is-open');
          var trigger = d.closest('[data-lang-switcher]').querySelector('[data-lang-trigger]');
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
        });
      }
    });

    document.addEventListener('cart:updated', (e) => {
      if (!this.cartCount) return;
      const count = e.detail && e.detail.itemCount != null ? e.detail.itemCount : 0;
      this.cartCount.textContent = count;
      this.cartCount.hidden = count === 0;
    });
  }

  _onScroll() {
    const y = window.scrollY;

    this.classList.toggle('header--scrolled', y > 50);

    if (y > this.lastScrollY && y > 100) {
      this.classList.add('header--hidden');
      this.isHidden = true;
    } else if (y < this.lastScrollY) {
      this.classList.remove('header--hidden');
      this.isHidden = false;
    }

    this.lastScrollY = y;
  }

  _openMenu() {
    this.mobileMenu.classList.add('is-open');
    this.menuToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    const close = (e) => {
      if (e.key === 'Escape') this._closeMenu();
    };
    document.addEventListener('keydown', close);
    this._closeEscHandler = close;
  }

  _closeMenu() {
    this.mobileMenu.classList.remove('is-open');
    this.menuToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    if (this._closeEscHandler) {
      document.removeEventListener('keydown', this._closeEscHandler);
    }
    this.menuToggle.focus();
  }
}

customElements.define('sticky-header', StickyHeader);
